<template>

    <div class="py-4 container-fluid">
      <div class="row">


        <div class="col-md-8">
          <div class="card mb-2">
            <div class="card-header pb-0">
              <div class="d-flex align-items-center">
                <p class="mb-0">Crear modelo</p>
                <argon-button  color="success" size="sm" class="ms-auto"  @click="save"
                  >Guardar</argon-button>
              </div>
            </div>
            <div class="card-body">
              <p class="text-uppercase text-sm">Información</p>
              <div class="row">
                <div class="col-md-6">
                  <label for="example-text-input" class="form-control-label"
                    >Nombre</label>
                  <argon-input type="text"  v-model="form.name"/>
                </div>
                <div class="col-md-6">
                  <label for="example-text-input" class="form-control-label"
                    >Referencia</label>
                  <argon-input type="text"  v-model="form.ref"/>
                </div>
                <div class="col-md-12">
                  <label for="example-text-input" class="form-control-label"
                    >Collección</label>
                  <argon-input type="text"  v-model="form.collection"/>
                </div>
                
                <div class="col-md-12">
                  <label for="processes-checkbox-list" class="form-control-label">Procesos</label>
                  <div id="processes-checkbox-list" class="checkbox-grid">
                    <div v-for="process in processes" :key="process.id" >
                      <argon-checkbox 
                        :id="'process-' + process.id" 
                        :value="process.id" 
                        :checked="form.processes.includes(process.id)"
                        v-model="form.processes" 
                      >
                        {{ process.name }}
                      </argon-checkbox>
                    </div>

                  </div>
                </div>


                <div class="col-md-6">
                  <label for="example-text-input" class="form-control-label"
                    >Genero</label
                  >
                  <select ref="GenderSelect" name="" id="category_gender" class="form-select" v-model="form.category_gender">
                    <option value="" disabled>Seleccionar</option>
                    <option v-for="option in genderOptions" :key="option.value" :value="option.value">
                      {{ option.label }}
                    </option>
                  </select>
                </div>
                
                <div class="col-md-6">
                  <label for="example-text-input" class="form-control-label"
                    >Categoria</label
                  >
                  <select name="" id="" class="form-select" v-model="form.category">
                    <option v-for="process in parents" :key="process.id" :value="process.id">
                      {{ process.name }}
                    </option>
                  </select>
                </div>
               
                <div class="col-md-12">
                  <label for="example-text-input" class="form-control-label"
                    >Descripción</label
                  >
                  <argon-textarea type="text"  v-model="form.description"/>
                </div>

                <div class="col-md-12">
                  <label for="example-text-input" class="form-control-label"
                    >Información del diseñador</label
                  >
                  <argon-textarea type="text"  v-model="form.description_desing"/>
                </div>

                <div class="col-md-6" v-if="form.id!=0">
                  <label for="example-text-input" class="form-control-label"
                    >Costo por unidad</label>
                  <argon-input type="text"  v-model="formattedPriceForm"/>
                </div>


                <div class="col-md-6 d-flex align-items-center mt-4">
                  <div class="form-check form-switch">
                    <input
                      class="form-check-input"
                      type="checkbox"
                      id="manageStock"
                      v-model="form.manage_stock"
                    />
                    <label class="form-check-label ms-2" for="manageStock">
                      Manejar stock del producto
                    </label>
                  </div>
                </div>

                <div class="col-md-6">
                  <label for="example-text-input" class="form-control-label"
                    >Estado</label
                  >
                  <select name="" id="" class="form-select" v-model="form.status">
                    <option value="1">En mejora</option>
                    <option value="0">Aprobado</option>
                    <option value="2">Rechazado</option>
                  </select>
                </div>


               
              </div>
            </div>
          </div>

          <div class="card" v-if="form.id!=0">

            <div class="card-header pb-0">
              <div class="d-flex align-items-center">
                <p class="text-uppercase mb-0">Lista de insumos</p>
                <argon-button  color="success" size="sm" class="ms-auto" @click="openModal"
                  >Asignar insumo</argon-button>
              </div>
            </div>

            <div class="card-body">
              <div class="row">
                
                <template v-for="(group, index) in data" :key="index">
                  <!-- Tabla para cada talla -->
                  <div class="table-responsive p-0 mb-4">


                    <div class="bg-light font-weight-bold rounded p-1 d-flex justify-content-between align-items-center px-2">
                      <div>
                        Talla: {{ group?.size?.size }}  - Color: {{ group?.size?.color?.name }} ({{ group?.size?.color?.ref }})
                      </div>
                      <a
                        @click="deleteModelRegister(group.id)"
                        class="text-secondary font-weight-bold text-xs cursor-pointer"
                        data-toggle="tooltip"
                        data-original-title="Eliminar registro"
                      >
                        <i class="fa fa-trash"></i>
                      </a>
                    </div>
                    
                   
                    <table class="table align-items-center mb-0">
                      <thead>
                        <tr>
                          <th class="text-uppercase text-secondary text-xxs font-weight-bolder opacity-7">Insumo</th>
                          <th class="text-center text-uppercase text-secondary text-xxs font-weight-bolder opacity-7">Cant/stock</th>
                          <th class="text-center text-uppercase text-secondary text-xxs font-weight-bolder opacity-7">Precio</th>
                          <th class="text-center text-uppercase text-secondary text-xxs font-weight-bolder opacity-7">Total</th>
                          <th class="text-uppercase text-secondary text-xxs font-weight-bolder opacity-7 text-center">Opciones</th>
                        </tr>
                      </thead>
                      <tbody>
                        <!-- Detalles del grupo -->
                        <tr v-for="detail in group.details" :key="detail.id">
                          <td>
                            <div class="d-flex px-2 py-1">
                              <div class="d-flex flex-column justify-content-center">
                                <h6 class="mb-0 text-sm">{{ detail.inventory.name }}</h6>
                              </div>
                            </div>
                          </td>
                          <td class="align-middle text-center text-sm d-flex" style="align-items: center;justify-content: center;">

                            <input 
                            class="form-control w-50" 
                            type="number" 
                            v-model.number="detail.quantity" 
                            :data-id="detail.id"
                            @change="onQuantityChange(detail, detail.quantity)"
                            onkeypress="return (event.keyCode >= 48 && event.keyCode <= 57) || event.keyCode === 46 || event.keyCode === 8 || event.keyCode === 37 || event.keyCode === 39 ? true : event.preventDefault()"
                          />                            
                          <span 
                              class="badge m-1" 
                              :class="{
                                'bg-danger': parseFloat(detail.inventory.quantity) < parseFloat(detail.quantity), 
                                'bg-secondary': parseFloat(detail.inventory.quantity) >= parseFloat(detail.quantity)
                              }">
                              {{ detail.inventory.quantity }}
                            </span>
                          </td>
                          <td class="align-middle text-center text-sm">
                            {{ parseFloat(detail.price).toLocaleString('es-ES', { minimumFractionDigits: 2, maximumFractionDigits: 2 }) }}
                          </td>
                          <td class="align-middle text-center text-sm">
                            {{ parseFloat(detail.total_price).toLocaleString('es-ES', { minimumFractionDigits: 2, maximumFractionDigits: 2 }) }}
                          </td>
                          <td class="align-middle text-center">
                            <a
                              @click="editModal(detail)" 
                              class="text-secondary font-weight-bold text-xs cursor-pointer"
                              data-toggle="tooltip"
                              data-original-title="Editar registro" 
                            >
                              <i class="fa fa-pencil-alt"></i>
                            </a>

                            <a
                              @click="deleteRegister(detail.id)" 
                              class="text-secondary font-weight-bold text-xs cursor-pointer"
                              style="margin-left: 15px;"
                              data-toggle="tooltip"
                              data-original-title="Eliminar registro" 
                            >
                              <i class="fa fa-trash"></i>
                            </a>
                          </td>
                        </tr>
                      </tbody>
                      <tfoot>
                        <tr>
                          <td colspan="3" class="text-end text-sm font-weight-bold">Total General:</td>
                          <td class="text-center text-sm font-weight-bold">
                            {{ (group?.total_for_size || 0).toLocaleString('es-ES', { minimumFractionDigits: 2, maximumFractionDigits: 2 }) }}                          </td>
                          <td colspan="2"></td>
                        </tr>
                      </tfoot>
                    </table>
                  </div>
                </template>

                <table class="table text-bold">
                  <tbody>
                    <tr>
                      <td>Promedio de costos por unidad</td>
                      <td style="text-align:right">{{ averageCost }}</td>
                    </tr>
                    
                  </tbody>
                </table>

              </div>
            </div>
          </div>
        </div>

     

        <div class="col-md-4" v-if="form.id!=0">
          <div class="card mb-2">
            <div class="card-header pb-0">
              <div class="d-flex align-items-center">
                <p class="mb-0">Imagenes</p>
              </div>
            </div>
            <div class="card-body">
              <div class="row">
                <div class="col-md-12">
                  <label for="example-text-input" class="form-control-label">Seleccionar imagen</label>
                  <input
                    class="form-control"
                    type="file"
                    id="fileImagen"
                   @change="saveImagenes"
                  />
                </div>
              </div>

              <div v-if="imagenes.length > 0" class="list-group">
                <div
                  v-for="(imagen, index) in imagenes"
                  :key="imagen.id"
                  class="list-group-item d-flex justify-content-between align-items-center mt-1"
                >
                  <span style="overflow: hidden; text-overflow: ellipsis; white-space: nowrap; display: inline-block;text-align: center;">
                    <div v-if="index === 0" class="text-center">
                      <img :src="this.apiUrl + imagen.file_path" alt="Imagen principal" class="img-fluid mb-2 w-50">
                    </div>
                    {{ imagen.file_name }}
                  </span>

                  <div style="align-items: center;display: flex;">
                    <a color="info"  v-if="index > 0" size="sm" @click="viewImage(imagen.file_path)">
                      <i class="fas fa-eye"></i>
                    </a>

                    <a
                    @click="deleteMedia(imagen.id)" 
                    class="text-secondary font-weight-bold text-xs cursor-pointer" style="margin-left: 5px;"
                    data-toggle="tooltip"
                    data-original-title="Eliminar registro" 
                      >
                      <i class="fa fa-trash"></i>
                    </a>
                  </div>
                </div>
              </div>
              <p v-else class="text-center mt-2">No hay imágenes disponibles.</p>

            </div>
          </div>

         

          <div class="card mb-2">
            <div class="card-header pb-0">
              <div class="d-flex align-items-center">
                <p class="mb-0">Muestras ejecutadas</p>
              </div>
            </div>
            <div class="card-body">
              <div class="row">
                <div class="col-md-12">
                  <label for="example-text-input" class="form-control-label"
                    >Seleccionar imagen</label>
                  <input class="form-control" type="file" name="" id="fileMuestras" @change="saveMuestras">
                </div>
              </div>

              <div v-if="muestras.length > 0" class="list-group">
                <div
                  v-for="imagen in muestras"
                  :key="imagen.id"
                  class="list-group-item d-flex justify-content-between align-items-center mt-1"
                >
                  <span style="overflow: hidden; text-overflow: ellipsis; white-space: nowrap; display: inline-block;text-align: center;">{{ imagen.file_name }}</span>
                  <div style="align-items: center;display: flex;">
                    <a color="info" size="sm" @click="viewImage(imagen.file_path)">
                      <i class="fas fa-eye"></i>
                    </a>
                    <a
                    @click="deleteMedia(imagen.id)" 
                    class="text-secondary font-weight-bold text-xs cursor-pointer" style="margin-left: 5px;"
                    data-toggle="tooltip"
                    data-original-title="Eliminar registro" 
                      >
                      <i class="fa fa-trash"></i>
                    </a>
                  </div>
                </div>
              </div>
              <p v-else class="text-center mt-2">No hay imágenes disponibles.</p>
            </div>
          </div>

          <div class="card mb-2">
            <div class="card-header pb-0">
              <div class="d-flex align-items-center">
                <p class="mb-0">Ficha técnica</p>
              </div>
            </div>
            <div class="card-body">
              <div class="row">
                <div class="col-md-12">
                  <label for="example-text-input" class="form-control-label"
                    >Seleccionar imagen</label>
                  <input class="form-control" type="file" name="" id="fileFicha" @change="saveFicha">
                </div>
              </div>
              <div v-if="fichas.length > 0" class="list-group">
                <div
                  v-for="imagen in fichas"
                  :key="imagen.id"
                  class="list-group-item d-flex justify-content-between align-items-center mt-1"
                >
                  <span style="overflow: hidden; text-overflow: ellipsis; white-space: nowrap; display: inline-block;text-align: center;">{{ imagen.file_name }}</span>
                  <div style="align-items: center;display: flex;">
                    <a color="info" size="sm" @click="viewPdf(imagen.file_path)">
                      <i class="fas fa-eye"></i>
                    </a>
                    <a
                    @click="deleteMedia(imagen.id)" 
                    class="text-secondary font-weight-bold text-xs cursor-pointer" style="margin-left: 5px;"
                    data-toggle="tooltip"
                    data-original-title="Eliminar registro" 
                      >
                      <i class="fa fa-trash"></i>
                    </a>
                  </div>
                </div>
              </div>
              <p v-else class="text-center mt-2">No hay imágenes disponibles.</p>
            </div>
          </div>

          <div class="card mb-2">
            <div class="card-header pb-0">
              <div class="d-flex align-items-center">
                <p class="mb-0">Tallas disponibles</p>
                <argon-button  color="success" size="sm" class="ms-auto"  @click="saveSize"
                  >Agregar</argon-button>
              </div>
            </div>
            <div class="card-body">
              <div class="row">
                <div class="col-12">
                  <label for="example-text-input" class="form-control-label"
                    >Talla</label>
                    <select name="" id="tallas" ref="tallasSelect"  class="form-select select2" multiple>
                      <option value="">Seleccionar</option>
                      <option v-for="size in sizesList" :key="size" :value="size">{{ size }}</option>
                    </select>
                </div>
                <div class="col-md-12">
                  <label for="example-text-input" class="form-control-label"
                    >Color</label>
                    <select name="" id="colores" ref="colorSelect" class="form-select select2" multiple>
                      <option value="">Seleccionar</option>
                      <option v-for="value in colors" :key="value.id" :value="value.id">{{ value.name }} ({{ value.ref }})</option>
                    </select>
                </div>

                <div class="table-responsive p-0">
                  <table class="table align-items-center mb-0">
                    <thead>
                      <tr>
                        <th
                          class="text-uppercase text-secondary text-xxs font-weight-bolder opacity-7"
                        >Talla</th>
                        <th
                          class="text-uppercase text-secondary text-xxs font-weight-bolder opacity-7"
                        >Color</th>
                        <th
                          class="text-uppercase text-secondary text-xxs font-weight-bolder opacity-7"
                        ></th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr  v-for="value in sizes" :key="value.id">
                        <td class="">{{ value.size }}</td>
                        <td class="">{{ value.color.name }} ({{ value.color.ref }})</td>
                        <td class="">
                          <a
                          @click="deleteSize(value.id)" 
                          class="text-secondary font-weight-bold text-xs cursor-pointer" style="margin-left: 15px;"
                          data-toggle="tooltip"
                          data-original-title="Eliminar registro" 
                        >
                          <i class="fa fa-trash"></i>
                        </a>
                        </td>
  

                      </tr>
                    </tbody>
                  </table>
                </div>

              </div>
            </div>
          </div>
        </div>


       



      </div>

    <!-- Modal Asignar tecnico -->
  <div class="modal fade" id="ModalBudget" tabindex="-1" aria-labelledby="exampleModalLabel" aria-hidden="true">
    <div class="modal-dialog">
      <div class="modal-content card">
        <div class="modal-header">
          <h5 class="modal-title" id="exampleModalLabel">Agregar insumo</h5>
          <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
        </div>
        <div class="modal-body">
          <form>

            <div class="mb-3">
              <label for="amount" class="form-label">Seleccionar Talla y color</label>
              <select ref="tallaSelect" id="sizes" class="form-select select2" multiple style="width:100%;" >
                <option v-for="process in sizes" :key="process.id" :value="process.id">
                  {{ process.size }} - {{ process.color.name }} ({{ process.color.ref }})
                </option>
              </select>
            </div>

            <div class="mb-3">
              <label for="amount" class="form-label">Insumo</label>
              <select ref="insumosSelect" id="insumos" class="form-select select2" multiple style="width:100%;" >
                <option v-for="process in insumos" :key="process.id" :value="process.id">
                  {{ process.name }} - ({{ process.ref }})
                </option>
              </select>
            </div>

          </form>
        </div>
        <div class="modal-footer">
          <button type="button" class="btn btn-secondary" @click="closeModal">Cerrar</button>
          <button type="button" class="btn btn-primary" @click="submitForm">Guardar</button>
        </div>
      </div>
    </div>
  </div>

  <div class="modal fade" id="ModalEditInsumo" tabindex="-1" aria-labelledby="exampleModalLabel" aria-hidden="true">
    <div class="modal-dialog">
      <div class="modal-content card">
        <div class="modal-header">
          <h5 class="modal-title" id="exampleModalLabel">Editar insumo</h5>
          <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
        </div>
        <div class="modal-body">
          <form>

            <div class="mb-3">
              <label class="form-label">Insumo</label>
              <select ref="insumosEditSelect" id="insumosEdit" class="form-select select2" style="width:100%;" >
                <option v-for="process in insumos" :key="process.id" :value="process.id">
                  {{ process.name }} - ({{ process.ref }})
                </option>
              </select>
            </div>

          </form>
        </div>
        <div class="modal-footer">
          <button type="button" class="btn btn-secondary" @click="closeEditModal">Cerrar</button>
          <button type="button" class="btn btn-primary" @click="submitEditForm">Guardar</button>
        </div>
      </div>
    </div>
  </div>

  </div>
</template>

<style scoped>
.checkbox-grid {
  display: grid;
  grid-template-columns: repeat(3, 1fr); /* Dos columnas iguales */
}
</style>

<script>
import setNavPills from "../../../assets/js/nav-pills.js";
import setTooltip from "../../../assets/js/tooltip.js";
import ArgonInput from "../../../components/ArgonInput.vue";
import ArgonTextarea from "../../../components/ArgonTextarea.vue";
import ArgonButton from "../../../components/ArgonButton.vue";
import ArgonCheckbox from "../../../components/ArgonCheckbox.vue";
import { useRoute } from "vue-router";
import Swal from 'sweetalert2';
import $ from 'jquery';
import 'select2/dist/css/select2.css';
import 'select2';
import { Modal } from 'bootstrap';

const body = document.getElementsByTagName("body")[0];

export default {
  name: "Models Create",
  data() {
    return {
      apiUrl: process.env.VUE_APP_API_IMAGE_URL,
      showMenu: false,
      modalBudget:null,
      modalEdit:null,
      isFinish:false,
      form: {
        id:0,
        name: '',
        ref: '',
        category_gender: '',
        category: '',
        collection: '',
        processes: [],
        description: '',
        description_desing: '',
        price: 0,
        manage_stock: true,
        status: 1,
      },
      genderOptions: [
        { value: 'male', label: 'Hombre' },
        { value: 'female', label: 'Mujer' },
        { value: 'boy', label: 'Niño' },
        { value: 'girl', label: 'Niña' },
      ],
      processes: [
      ],
      size:{
        size:[],
        color_id:[],
        model_id:'',
        quantity:0,
        status:1
      },
      sizesList: [
      ],
      categories:[],
      parents:[],
      imagenes:[],
      muestras:[],
      fichas:[],
      insumos: [],
      users: [],
      colors: [],
      sizes:[],
      data: [],
      modal: {
        id:0,
        user_id: null,
        project_id: null,
        amount: "",
        status: "active"
      },
      purchase:{
        id:0,
        model_id:0,
        inventory_id:[],
        quantity:0,
        price:0,
        total_price:0,
        size_id:[],
      },
      modalEvidencia: []
    };
  },
  components: { ArgonInput, ArgonButton,ArgonTextarea,ArgonCheckbox },
  computed: {
    averageCost() {
      const totalCost = this.data.reduce((sum, group) => sum + (group.total_for_size || 0), 0);
      const itemCount = this.data.length;
      const promedio = itemCount > 0 ? (totalCost / itemCount).toFixed(2) : "0.00";
      return parseFloat(promedio).toLocaleString('es-ES', { minimumFractionDigits: 2, maximumFractionDigits: 2 }) 
    },
    formattedPriceForm: {
      get() {
        return this.form.price.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ".");
      },
      set(value) {
        this.form.price = parseFloat(value.replace(/\./g, "") || 0);
        // Si el precio por unidad cambia, actualiza el total automáticamente
      },
    },
    formattedTotalBudget: {
      get() {
        // Formatea el total_budget a punto de mil
        return this.form.total_budget.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ".");
      },
      set(value) {
        // Elimina los puntos y actualiza el total_budget
        this.form.total_budget = parseFloat(value.replace(/\./g, "") || 0);
      },
    },
    formattedAmount: {
      get() {
        // Formatea el total_budget a punto de mil
        return this.modal.amount.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ".");
      },
      set(value) {
        // Elimina los puntos y actualiza el total_budget
        this.modal.amount = parseFloat(value.replace(/\./g, "") || 0);
      },
    },
    formattedPrice: {
      get() {
        return this.purchase.price.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ".");
      },
      set(value) {
        this.purchase.price = parseFloat(value.replace(/\./g, "") || 0);
      },
    },
    totalPrice() {
      // Calcula el total y aplica el formateo
      const total = Math.floor(this.purchase.quantity * this.purchase.price);
      return total
        ? total.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ".")
        : "0";
    },
  },
  methods: {
    normalizeBoolean(value) {
      if (value === undefined || value === null) {
        return true;
      }
      if (typeof value === 'string') {
        return value === '1' || value.toLowerCase() === 'true';
      }
      return value === 1 || value === true;
    },
    async onQuantityChange(value, newQuantity) {

      this.purchase.id = value.id;
      this.purchase.inventory_id = value.inventory_id;
      this.purchase.quantity = newQuantity;
      await this.$store.dispatch("modelsDetails/save", this.purchase);

      this.getData();

    },
    async getTallas() {
      const response = await this.$store.dispatch("tallas/getAll");
      this.sizesList = response.map(item => item.size);
    },
    async getCategories() {
      const response = await this.$store.dispatch("categories/getCategories");
      this.categories = response.data;
      this.categories.sort((a, b) => a.name.localeCompare(b.name));
      this.parents = this.categories.filter(category => category.parent_id === null);
    },
    async getParents() {
      this.parents = this.categories.filter(category => category.parent_id === null);
    },
    async getImages() {
      let media =  await this.$store.dispatch('media/getData',this.form.id); 

      this.imagenes = media.data.filter(item => item.mediaable_type === 'imagenes');
      this.muestras = media.data.filter(item => item.mediaable_type === 'muestras');
      this.fichas = media.data.filter(item => item.mediaable_type === 'ficha');
    },
    getIconClass(status) {
      if (status === 0) {
        return 'fa fa-circle'; // Ícono de clic
      } else if (status === 1) {
        return 'fa fa-check-circle text-success'; // Ícono de check verde
      } else if (status === 2) {
        return 'fa fa-times-circle text-danger'; // Ícono de X roja
      }
      return ''; // Devuelve una cadena vacía si no coincide con ningún estado
    },
    openModal() {
      const modalElement = document.getElementById('ModalBudget');
      this.modalBudget = new Modal(modalElement); // Guarda la instancia del modal
      this.modalBudget.show(); // Muestra el modal
    },
    closeModal() {
      if (this.modalBudget) {
        this.modalBudget.hide(); // Cierra el modal
      }
    },
    editModal(detail) {
      this.purchase = {
        id:detail.id,
        inventory_id: detail.inventory_id,
        quantity:detail.quantity,
      };

      $('#insumosEdit').val(detail.inventory_id).trigger('change');
      const modalElement = document.getElementById('ModalEditInsumo');
      this.modalEdit = new Modal(modalElement); // Guarda la instancia del modal
      this.modalEdit.show(); // Muestra el modal
    },
    closeEditModal() {
      if (this.modalEdit) {
        this.modalEdit.hide(); // Cierra el modal
      }
    },
    async getInsumos() {
      this.insumos = await this.$store.dispatch('inventory/getAll'); 
    },
    async getData() {
      await this.$store.dispatch('modelsModel/getData',this.form.id); 
      this.data = this.$store.state.modelsModel.getData;
    },
    async getOficios() {
      this.processes =  await this.$store.dispatch('users/getOficios'); 
    },
    async getColors() {
      this.colors =  await this.$store.dispatch('models/colors'); 
    },
    async getSizes() {
      this.sizes =  await this.$store.dispatch('models/sizes',this.form.id); 
    },
    async saveSize() {

      try {

        if (!this.size.color_id || !this.size.size) {
            await Swal.fire({
                icon: 'error',
                title: '¡Error!',
                text: 'Por favor, asegúrese de seleccionar un color y una talla.',
                confirmButtonText: 'Aceptar',
            });
            return; // Detener la ejecución si falta algún campo
        }

        // Dispara la acción de Vuex para guardar el estudiante
        const response = await this.$store.dispatch("models/saveSize", this.size);
        if (response && response.status >= 200 && response.status < 300) {
          await Swal.fire({
              icon: 'success',
              title: '¡Éxito!',
              text: 'la talla ha sido guardado correctamente.',
              confirmButtonText: 'Aceptar',
              backdrop: true,
          }).then((result) => {
              if (result.isConfirmed) {
                this.getSizes();
                this.size.size = '';
                this.size.color = '';
                this.size.quantity = 0;

                $(this.$refs.tallasSelect).val([]).trigger('change');
                $(this.$refs.colorSelect).val([]).trigger('change');

              }
          });

        }else{
          throw new Error(response.data.message || 'Error al guardar la talla');
        }

      } catch (error) {
        console.error("Error al crear la talla:", error);
        await Swal.fire({
            icon: 'error',
            title: 'Error',
            text: error.message || 'Error al guardar el proyecto',
        });
      } 
    },
    async deleteMedia(idd) {
       await this.$store.dispatch("media/delete", idd);
       this.getImages();
    },
    async deleteSize(idd) {
       const response = await this.$store.dispatch("sizes/delete", idd);
        if (response && response.status >= 200 && response.status < 300) {
          await Swal.fire({
              icon: 'success',
              title: '¡Éxito!',
              text: 'la talla ha sido eliminada correctamente.',
              confirmButtonText: 'Aceptar',
              backdrop: true,
          });

          this.getSizes();

        }else{
          await Swal.fire({
              icon: 'error',
              title: 'Error',
              text: 'Ya hay insumos relacionados con la talla, primero elimine el modelo en insumos',
          });
        }
    },
    async save() {
      try {
        // Dispara la acción de Vuex para guardar el estudiante
        const response = await this.$store.dispatch("models/save", this.form);
        if (response && response.status >= 200 && response.status < 300) {
          await Swal.fire({
              icon: 'success',
              title: '¡Éxito!',
              text: 'El proyecto ha sido guardado correctamente.',
              confirmButtonText: 'Aceptar',
              backdrop: true,
          }).then((result) => {
              if (result.isConfirmed) {
                this.form = response.data;
                this.form.id = response.data.id || 0;
                this.form.manage_stock = this.normalizeBoolean(response.data.manage_stock);
                this.size.model_id = response.data.id || 0;
                this.modal.project_id = response.data.id || 0;
                this.purchase.model_id = response.data.id || 0;

                this.$nextTick(() => {
                    $(this.$refs.userSelect).select2({
                      placeholder: 'Seleccione un usuario',
                      allowClear: false,
                      dropdownParent: $('#ModalBudget .modal-body')
                    });
                    // Actualizar el valor cuando se seleccione una opción en select2
                    $(this.$refs.userSelect).on('change', () => {
                      this.modal.user_id = $(this.$refs.userSelect).val();
                    });

                    $(this.$refs.insumosSelect).select2({
                      placeholder: 'Seleccione un insumo',
                      allowClear: false,
                      dropdownParent: $('#ModalBudget .modal-body')
                    });
                    // Actualizar el valor cuando se seleccione una opción en select2
                    $(this.$refs.insumosSelect).on('change', () => {
                      this.purchase.inventory_id = $(this.$refs.insumosSelect).val();
                    });

                    $(this.$refs.insumosEditSelect).select2({
                      placeholder: 'Seleccione un insumo',
                      allowClear: false,
                      dropdownParent: $('#ModalEditInsumo .modal-body')
                    });
                    // Actualizar el valor cuando se seleccione una opción en select2
                    $(this.$refs.insumosEditSelect).on('change', () => {
                      this.purchase.inventory_id = $(this.$refs.insumosEditSelect).val();
                    });

                    

                    $(this.$refs.tallaSelect).select2({
                      placeholder: 'Seleccione un talla y color',
                      allowClear: false,
                      dropdownParent: $('#ModalBudget .modal-body')
                    });
                    // Actualizar el valor cuando se seleccione una opción en select2
                    $(this.$refs.tallaSelect).on('change', () => {
                      this.purchase.size_id = $(this.$refs.tallaSelect).val();
                    });


                    $(this.$refs.tallasSelect).select2({
                      placeholder: 'Seleccione una talla',
                      allowClear: false,
                    });
                    // Actualizar el valor cuando se seleccione una opción en select2
                    $(this.$refs.tallasSelect).on('change', () => {
                      this.size.size = $(this.$refs.tallasSelect).val();
                    });

                    $(this.$refs.colorSelect).select2({
                      placeholder: 'Seleccione colores',
                      allowClear: false,
                    });
                    // Actualizar el valor cuando se seleccione una opción en select2
                    $(this.$refs.colorSelect).on('change', () => {
                      this.size.color_id = $(this.$refs.colorSelect).val();
                    });

                  });
                  
              }
          });

        }else{
          throw new Error(response.data.message || 'Error al guardar el proyecto');
        }

      } catch (error) {
        console.error("Error al crear el proyecto:", error);
        await Swal.fire({
            icon: 'error',
            title: 'Error',
            text: error.message || 'Error al guardar el proyecto',
        });
      }
    },
    async saveImagenes() {
      try {

        const fileInput = document.getElementById("fileImagen");
        const file = fileInput.files[0];

        const formData = new FormData();
        formData.append("mediaable_id", this.form.id);
        formData.append("mediaable_type", 'imagenes');
        formData.append("file", file);

        // Dispara la acción de Vuex para guardar el estudiante
        const response = await this.$store.dispatch("media/save", formData);
        if (response && response.status >= 200 && response.status < 300) {
          await Swal.fire({
              icon: 'success',
              title: '¡Éxito!',
              text: 'El proyecto ha sido guardado correctamente.',
              confirmButtonText: 'Aceptar',
              backdrop: true,
          }).then((result) => {
              if (result.isConfirmed) {
                this.getImages();
                fileInput.value = '';
              }
          });

        }else{
          throw new Error(response.data.message || 'Error al guardar el proyecto');
        }

      } catch (error) {
        console.error("Error al crear el proyecto:", error);
        await Swal.fire({
            icon: 'error',
            title: 'Error',
            text: error.message || 'Error al guardar el proyecto',
        });
      }
    },
    async saveMuestras() {
      try {

        const fileInput = document.getElementById("fileMuestras");
        const file = fileInput.files[0];

        const formData = new FormData();
        formData.append("mediaable_id", this.form.id);
        formData.append("mediaable_type", 'muestras');
        formData.append("file", file);

        // Dispara la acción de Vuex para guardar el estudiante
        const response = await this.$store.dispatch("media/save", formData);
        if (response && response.status >= 200 && response.status < 300) {
          await Swal.fire({
              icon: 'success',
              title: '¡Éxito!',
              text: 'El proyecto ha sido guardado correctamente.',
              confirmButtonText: 'Aceptar',
              backdrop: true,
          }).then((result) => {
              if (result.isConfirmed) {
                fileInput.value = '';
                this.getImages();
              }
          });

        }else{
          throw new Error(response.data.message || 'Error al guardar el proyecto');
        }

      } catch (error) {
        console.error("Error al crear el proyecto:", error);
        await Swal.fire({
            icon: 'error',
            title: 'Error',
            text: error.message || 'Error al guardar el proyecto',
        });
      }
    },
    async saveFicha() {
      try {

        const fileInput = document.getElementById("fileFicha");
        const file = fileInput.files[0];

        const formData = new FormData();
        formData.append("mediaable_id", this.form.id);
        formData.append("mediaable_type", 'ficha');
        formData.append("file", file);

        // Dispara la acción de Vuex para guardar el estudiante
        const response = await this.$store.dispatch("media/save", formData);
        if (response && response.status >= 200 && response.status < 300) {
          await Swal.fire({
              icon: 'success',
              title: '¡Éxito!',
              text: 'El proyecto ha sido guardado correctamente.',
              confirmButtonText: 'Aceptar',
              backdrop: true,
          }).then((result) => {
              if (result.isConfirmed) {
                this.getImages();
                fileInput.value = '';
              }
          });

        }else{
          throw new Error(response.data.message || 'Error al guardar el proyecto');
        }

      } catch (error) {
        console.error("Error al crear el proyecto:", error);
        await Swal.fire({
            icon: 'error',
            title: 'Error',
            text: error.message || 'Error al guardar el proyecto',
        });
      }
    },
    async submitEditForm(){

      try {
        const response = await this.$store.dispatch("modelsDetails/save", this.purchase);
        if (response && response.status >= 200 && response.status < 300) {
          await Swal.fire({
              icon: 'success',
              title: '¡Éxito!',
              text: 'El registro ha sido guardado correctamente.',
              confirmButtonText: 'Aceptar',
              backdrop: true,
          }).then(() => {
            this.getData();
            this.closeEditModal();
          });
        }else{
          throw new Error(response.data.message || 'Error al guardar el registro');
        }
      } catch (error) {
        Swal.close();
        console.error("Error al crear el registro:", error);
        await Swal.fire({
            icon: 'error',
            title: 'Error',
            text: error.message || 'Error al guardar el registro',
        });
      } 
    },
    async submitForm() {
      try {

        Swal.fire({
          icon: 'info',
          title: 'Cargando...',
          text: 'Estamos obteniendo los datos, por favor espera.',
          didOpen: () => {
            Swal.showLoading();
          },
          confirmButtonText: 'Aceptar',
          backdrop: true,
        });
        // Dispara la acción de Vuex para guardar el estudiante
        const response = await this.$store.dispatch("modelsModel/save", this.purchase);
    
        if (response && response.status >= 200 && response.status < 300) {
          await Swal.fire({
              icon: 'success',
              title: '¡Éxito!',
              text: 'El registro ha sido guardado correctamente.',
              confirmButtonText: 'Aceptar',
              backdrop: true,
          }).then((result) => {
            Swal.close();
              if (result.isConfirmed) {
                this.getData();
                this.closeModal();
                
                $(this.$refs.tallaSelect).val(null).trigger('change');
                $(this.$refs.insumosSelect).val(null).trigger('change');

              }
          });
        }else{
          throw new Error(response.data.message || 'Error al guardar el registro');
        }
        
      } catch (error) {
        Swal.close();
        console.error("Error al crear el registro:", error);
        await Swal.fire({
            icon: 'error',
            title: 'Error',
            text: error.message || 'Error al guardar el registro',
        });
      } 
    
    },
    async deleteRegister(userId) {
      try {
        const result = await Swal.fire({
          title: '¿Estás seguro?',
          text: 'Esta acción no se puede deshacer.',
          icon: 'warning',
          showCancelButton: false,
          confirmButtonColor: '#d33',
          cancelButtonColor: '#3085d6',
          confirmButtonText: 'Sí, eliminar!',
          cancelButtonText: 'Cancelar'
        });

        if (result.isConfirmed) {
          const response = await this.$store.dispatch("modelsDetails/delete", userId);
          if (response && response.status >= 200 && response.status < 300) {

            await Swal.fire(
              'Eliminado!',
              'El registro ha sido eliminado correctamente.',
              'success'
            );

            this.getData();
          } else {
            throw new Error(response.data.message || 'Error al eliminar el registro');
          }
        }
      } catch (error) {
        console.error("Error al eliminar el registro:", error);
        await Swal.fire({
          icon: 'error',
          title: 'Error',
          text: error.message || 'Error al eliminar el registro',
        });
      }
    },
    async deleteModelRegister(userId) {

      try {
        const result = await Swal.fire({
          title: '¿Estás seguro?',
          text: 'Esta acción no se puede deshacer.',
          icon: 'warning',
          showCancelButton: false,
          confirmButtonColor: '#d33',
          cancelButtonColor: '#3085d6',
          confirmButtonText: 'Sí, eliminar!',
          cancelButtonText: 'Cancelar'
        });

        if (result.isConfirmed) {
          const response = await this.$store.dispatch("modelsModel/delete", userId);
          if (response && response.status >= 200 && response.status < 300) {

            await Swal.fire(
              'Eliminado!',
              'El registro ha sido eliminado correctamente.',
              'success'
            );

            this.getData();
          } else {
            throw new Error(response.data.message || 'Error al eliminar el registro');
          }
        }
      } catch (error) {
        console.error("Error al eliminar el registro:", error);
        await Swal.fire({
          icon: 'error',
          title: 'Error',
          text: error.message || 'Error al eliminar el registro',
        });
      }
    },
    viewPdf(file_path) {
      const pdfUrl = this.apiUrl + file_path;
      window.open(pdfUrl, '_blank');
    },
    viewImage(file_path) {

      const imageHtml = `<img src="${this.apiUrl + file_path}" alt="Evidencia" style="width: 100%; height: auto;" />`;

      // Mostrar la imagen en un SweetAlert
      Swal.fire({
          html: imageHtml,
          showCloseButton: true,
          showCancelButton: false,
          focusConfirm: false,
          confirmButtonText: 'Cerrar',
          backdrop: false, 
          customClass: {
              popup: 'modal-dialog modal-dialog-centered', // Clases de Bootstrap para el modal
          },
      });
    },
  
  },
  mounted() {

    this.getTallas();

    this.getCategories();

    this.getInsumos();

    this.getOficios();

    const route = useRoute();
    const dataEdit = route.params.data;


    this.$nextTick(() => {
      $(this.$refs.userSelect).select2({
        placeholder: 'Seleccione un usuario',
        allowClear: false,
        dropdownParent: $('#ModalBudget .modal-body')
      });
      // Actualizar el valor cuando se seleccione una opción en select2
      $(this.$refs.userSelect).on('change', () => {
        this.modal.user_id = $(this.$refs.userSelect).val();
      });

      $(this.$refs.insumosSelect).select2({
        placeholder: 'Seleccione un insumo',
        allowClear: false,
        dropdownParent: $('#ModalBudget .modal-body')
      });
      // Actualizar el valor cuando se seleccione una opción en select2
      $(this.$refs.insumosSelect).on('change', () => {
        this.purchase.inventory_id = $(this.$refs.insumosSelect).val();
      });

      $(this.$refs.insumosEditSelect).select2({
        placeholder: 'Seleccione un insumo',
        allowClear: false,
        dropdownParent: $('#ModalEditInsumo .modal-body')
      });
      // Actualizar el valor cuando se seleccione una opción en select2
      $(this.$refs.insumosEditSelect).on('change', () => {
        this.purchase.inventory_id = $(this.$refs.insumosEditSelect).val();
      });

      $(this.$refs.tallaSelect).select2({
        placeholder: 'Seleccione un talla y color',
        allowClear: false,
        dropdownParent: $('#ModalBudget .modal-body')
      });
      // Actualizar el valor cuando se seleccione una opción en select2
      $(this.$refs.tallaSelect).on('change', () => {
        this.purchase.size_id = $(this.$refs.tallaSelect).val();
      });


      $(this.$refs.tallasSelect).select2({
        placeholder: 'Seleccione una talla',
        allowClear: false,
      });
      // Actualizar el valor cuando se seleccione una opción en select2
      $(this.$refs.tallasSelect).on('change', () => {
        this.size.size = $(this.$refs.tallasSelect).val();
      });

      $(this.$refs.colorSelect).select2({
        placeholder: 'Seleccione colores',
        allowClear: false,
      });
      // Actualizar el valor cuando se seleccione una opción en select2
      $(this.$refs.colorSelect).on('change', () => {
        this.size.color_id = $(this.$refs.colorSelect).val();
      });

    });

    if (dataEdit) {
        try {
            const params = JSON.parse(dataEdit); 

            if (params && params.id) {
                this.size.model_id = params.id || 0;

                this.purchase.model_id  = params.id || 0;

                this.form.id = params.id || 0;
                this.form.name = params.name || '';
                this.form.ref = params.ref || 0;
                this.form.category_gender = params.category_gender || '';

                this.form.collection = params.collection || '';
                this.form.category = params.category || 1;

                this.form.processes = JSON.parse(params.processes) || []; 
                $(this.$refs.processesSelect).val(this.form.processes).trigger('change');


                this.form.description = params.description || '';
                this.form.description_desing = params.description_desing || '';
                this.form.price = parseInt(params.price || 0); 
                this.form.manage_stock = this.normalizeBoolean(params.manage_stock);
                this.form.status = params.status || 0; 
                this.modal.project_id = params.id || 0;

                this.isFinish = !!params.status;


                this.getImages();

            }
        } catch (error) {
            console.error("Error al parsear los datos del registro:", error);
        }

        this.getData();
    }

    
    this.getSizes();

    this.getColors();

    this.$store.state.isAbsolute = false;
    setNavPills();
    setTooltip();
  },
  beforeMount() {

    $(this.$refs.userSelect).select2('destroy');

    this.$store.state.imageLayout = "profile-overview";
    this.$store.state.showNavbar = true;
    this.$store.state.showFooter = true;
    this.$store.state.hideConfigButton = true;
    body.classList.add("profile-overview");
  },
  beforeUnmount() {
    this.$store.state.isAbsolute = false;
    this.$store.state.imageLayout = "default";
    this.$store.state.showNavbar = true;
    this.$store.state.showFooter = true;
    this.$store.state.hideConfigButton = false;
    body.classList.remove("profile-overview");
  }
};
</script>

<style>
.disabled-link {
  color: gray;
  pointer-events: none; /* Impide la interacción */
  cursor: not-allowed; /* Cambia el cursor para indicar que está deshabilitado */
}
</style>


